import { checkPermission } from "../../helpers/permissions";
import { getToken, onMessage } from "firebase/messaging";
import { messaging } from "../../firebaseConfig";
import { updateFCM } from "../../context/actions/firebase/firbase";

let isGeneratingToken = false;
let lastSentToken = null;
let lastSentAuthToken = null;

export const fcmGenerate = (setNotification) => {
  if (!messaging) {
    console.warn("fcmGenerate: messaging not initialized");
    return;
  }

  const hasPermission = checkPermission("manage_texting");
  console.log("fcmGenerate: Initialization started. Permission:", hasPermission);

  // Exclude unauthenticated/guest routes like Texting Invite
  const unauthRoutes = ['/texting-invite', '/login', '/reset-password', '/forgot-password', '/register', '/order', '/submit-feedback', '/qr/', '/venue/', '/sso/'];
  if (unauthRoutes.some(route => window.location.pathname.startsWith(route))) {
    console.log("fcmGenerate: Skipping for unauthenticated route.");
    return;
  }

  async function generateToken() {
    if (isGeneratingToken) {
      console.log("fcmGenerate: Token generation already in progress. Skipping.");
      return;
    }
    isGeneratingToken = true;

    try {
      if (!hasPermission) {
        console.warn("fcmGenerate: 'manage_texting' permission missing.");
        return;
      }

      console.log("fcmGenerate: Checking Notification.permission:", Notification.permission);

      if (Notification.permission === "default") {
        console.log("fcmGenerate: Permission is default. Waiting for user interaction to request permission.");
        return;
      }

      if (Notification.permission === "granted") {
        // Generate Token
        try {
          console.log("fcmGenerate: Attempting to get token...");

          // Wait for service worker registration to be ready
          const registration = await navigator.serviceWorker.ready;
          console.log("fcmGenerate: Service Worker Ready with scope:", registration.scope);

          const token = await getToken(messaging, {
            vapidKey: process.env.REACT_APP_VAPID_KEY,
            serviceWorkerRegistration: registration
          });

          const currentAuthToken = localStorage.getItem('token');
          if (token === lastSentToken && currentAuthToken === lastSentAuthToken) {
            console.log("fcmGenerate: Token and Auth are same as last sent. Skipping API call.");
            return;
          }

          console.log("Token Gen", token);
          lastSentToken = token;
          lastSentAuthToken = currentAuthToken;
          localStorage.setItem('fcm_token', token);

          updateFCM({ fcm_token: token })((response) => {
            if (response?.status) {
              console.log("FCM Token Updated", response);
            } else {
              console.log("FCM Token Update Failed", response);
            }
          });
        } catch (error) {
          console.error("fcmGenerate: Error generating token:", error);
        }
      } else {
        console.warn("fcmGenerate: Notification permission is", Notification.permission);
      }
    } finally {
      // Release lock
      isGeneratingToken = false;
    }
  }

  generateToken();

  const unsubscribe = onMessage(messaging, (payload) => {
    console.log("fcmGenerate: Foreground message received", payload);
    if (!hasPermission) {
      console.log("fcmGenerate: Permission denied for foreground message");
      return;
    }
    const notification = payload.notification || {};
    const data = payload.data || {};

    const title = notification.title || data.title;
    const body = notification.body || data.body;
    const icon = notification.icon || data.icon;
    const contact_id = notification.contact_id || data.contact_id;
    setNotification({ title, body, icon, contact_id });
    // toast(body);
  });

  // Listen for messages from Service Worker (Manual Fallback)
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.addEventListener('message', (event) => {
      if (event.data && event.data.type === 'FOREGROUND_MESSAGE') {
        console.log("fcmGenerate: Received manual foreground message from SW", event.data.payload);
        if (!hasPermission) return;

        const payload = event.data.payload;
        const notification = payload.notification || {};
        const data = payload.data || {};

        const title = notification.title || data.title;
        const body = notification.body || data.body;
        const icon = notification.icon || data.icon;
        const contact_id = notification.contact_id || data.contact_id;

        setNotification({ title, body, icon, contact_id });
      }
    });
  }

  return unsubscribe;

};
